import { hasOwnProperties } from "./utils"

export default function signUp(settings = {}) {
  const init = import(/* webpackChunkName: "signup" */ "./init")
  const vue = import(/* webpackChunkName: "vue" */ "vue/dist/vue.runtime.esm")
  const data = fetch("/sign_up/support", { credentials: "include" }).then((res) => {
    if (res.ok) return res.json()

    return new Error(`${res.status}: ${res.statusText}`)
  })

  return Promise.all([init, vue, data]).then(([module, { default: Vue }, dataset]) => {
    const props = ["localization", "needSignUp", "currencies", "iso_countries", "offers"]
    if (hasOwnProperties(props, dataset)) return module.default(dataset, Vue, settings)

    return new Error("There are no required properties in the response object")
  })
}
